import React, { useState } from "react";
import "./BusinessStartSection.css";

const tabs = ["Popular", "Domains", "Hosting"];

const cards = {
  Popular: [
    {
      title: "AI website starter",
      text: "Create a clean business landing page and connect it with your domain in a few simple steps.",
      tag: "New",
      button: "Start today",
      type: "large",
    },
    {
      title: ".com launch offer",
      text: "Start your brand with a trusted extension at simple first-year pricing.",
      tag: "Deal",
      button: "Get offer",
    },
    {
      title: "Business email",
      text: "Use branded email addresses for sales, support, and client communication.",
      tag: "Pro",
      button: "Set up email",
    },
  ],
  Domains: [
    {
      title: "Find your perfect domain",
      text: "Search popular extensions and secure the name that fits your brand.",
      tag: "Search",
      button: "Find domain",
      type: "large",
    },
    {
      title: "Domain privacy",
      text: "Protect your ownership details and keep your brand safer online.",
      tag: "Secure",
      button: "Learn more",
    },
    {
      title: "Easy renewals",
      text: "Track renewal dates and manage your domains from one dashboard.",
      tag: "Manage",
      button: "View tools",
    },
  ],
  Hosting: [
    {
      title: "Fast hosting setup",
      text: "Connect your domain with reliable hosting built for business websites.",
      tag: "Hosting",
      button: "Explore hosting",
      type: "large",
    },
    {
      title: "SSL protection",
      text: "Launch with HTTPS and give your visitors a secure browsing experience.",
      tag: "SSL",
      button: "Secure site",
    },
    {
      title: "Website security",
      text: "Keep your website protected with safer access and cleaner controls.",
      tag: "Safety",
      button: "Protect now",
    },
  ],
};

const BusinessStartSection = () => {
  const [activeTab, setActiveTab] = useState("Popular");

  return (
    <section className="bs-section">
      <div className="bs-container">
        <div className="bs-heading">
          <h2>What should your business launch first?</h2>

          <div className="bs-tabs">
            {tabs.map((tab) => (
              <button
                type="button"
                key={tab}
                className={activeTab === tab ? "active" : ""}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="bs-grid">
          {cards[activeTab].map((card) => (
            <article
              className={`bs-card ${card.type === "large" ? "bs-card-large" : ""}`}
              key={card.title}
            >
              <div className="bs-visual">
                <span>{card.tag}</span>
              </div>

              <div className="bs-content">
                <h3>{card.title}</h3>
                <p>{card.text}</p>
                <button type="button">{card.button}</button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BusinessStartSection;